export class Protocol {
    name: string;
    endpoint: string;
}
